import React, { useRef } from 'react';
import {
    Area, FlexRow, FlexColumn, Title, RedStripe, RedTextTitle, BlueText, MoreInfo,
    ArrowCircleIcon, InsuranceContainer, UmbrellaIcon, InsuranceListItem,
    InsuranceLITitle, InsuranceLIText, InsuranceCTA, SavingIcon, ShieldIcon, TimerIcon,
} from './index.style';

const Insurance = ({ insurance: {
    title, text, moreInfo, list1, list2, list3, cta
} }) => {
    const moreInfoEl = useRef(null);
    const clickMoreInfo = () => moreInfoEl.current.click();
    return (<InsuranceContainer>
        <Area>
            <FlexRow style={{ marginBottom: '63px' }}>
                <FlexColumn>
                    <Title onClick={clickMoreInfo}>
                        <RedStripe />
                        ביטוח
                        </Title>
                    {!!title &&
                        <RedTextTitle onClick={clickMoreInfo}>{title.text}</RedTextTitle>}
                    {!!text &&
                        <BlueText onClick={clickMoreInfo}>{text.text}</BlueText>}
                    {!!moreInfo &&
                        <MoreInfo
                            ref={moreInfoEl}
                            to='/insurance'
                        >
                            {moreInfo.text}
                            <ArrowCircleIcon />
                        </MoreInfo>}
                </FlexColumn>
                <FlexColumn>
                    <UmbrellaIcon />
                </FlexColumn>
            </FlexRow>
            <FlexRow style={{ justifyContent: 'space-between', marginBottom: '60px' }}>
                <InsuranceListItem>
                    <ShieldIcon />
                    
                    <InsuranceLITitle>
                        {list1.title.text}
                    </InsuranceLITitle>
                    <InsuranceLIText>
                        {list1.text.text}
                    </InsuranceLIText>
                </InsuranceListItem>
                <InsuranceListItem>
                    <SavingIcon />
                    <InsuranceLITitle>
                        {list2.title.text}
                    </InsuranceLITitle>
                    <InsuranceLIText>
                        {list2.text.text}
                    </InsuranceLIText>
                </InsuranceListItem>
                <InsuranceListItem>
                    <TimerIcon />
                    <InsuranceLITitle>
                        {list3.title.text}
                    </InsuranceLITitle>
                    <InsuranceLIText>
                        {list3.text.text}
                    </InsuranceLIText>
                </InsuranceListItem>
            </FlexRow>
            {!!cta &&
                <InsuranceCTA to='/insurance'>{cta.text}</InsuranceCTA>}
        </Area>
    </InsuranceContainer>);
};

export default Insurance;